export default __webpack_public_path__ + "static/media/logo-patrocinador4.b5a07db8.svg";